<div class="dropdown">
    <ng-container *ngIf="!readonly; else readonlyBlock">
        <a class="dropdown-toggle"
           data-toggle="dropdown"
           role="button"
           aria-haspopup="true"
           aria-expanded="false">
            <span class="position-name">Lock</span>
        </a>

        <div class="dropdown-menu">
            <a (click)="onLock()"
               class="dropdown-item">
                <i class="fa fa-fw fa-lock" aria-hidden="true"></i>
                Lock All
            </a>

            <a (click)="onUnlock()"
               class="dropdown-item">
                <i class="fa fa-fw fa-unlock-alt unlocked-indicator" aria-hidden="true"></i>
                Unlock All
            </a>
        </div>
    </ng-container>

    <ng-template #readonlyBlock>
        <span class="position-name">
            Lock
            <info-tooltip class="tool-tip padding-left-5"
                          [placement]="'right-top'"
                          [text]="'Only ' + ('Study' | translate) + ' Administrators can lock or unlock tasks'">
            </info-tooltip>
        </span>
    </ng-template>
</div>
